import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, map } from 'rxjs';

import { TitleService } from '@core/services/title.service';

import { selectHasMultipleTenants, selectSelectedTenantName } from '../store/multi-site-dashboard.selectors';

export const setCustomTitleForMultiSiteDashboard = (translationKey: string): void => {
  const store = inject(Store);
  const titleService = inject(TitleService);
  const translateService = inject(TranslateService);

  // Append the selected tenant name only when the user has access to more than one tenant.
  const title$ = combineLatest([
    translateService.stream(translationKey),
    store.select(selectSelectedTenantName),
    store.select(selectHasMultipleTenants),
  ]).pipe(map(([title, tenantName, hasMultipleTenants]) => (hasMultipleTenants && tenantName ? `${title} - ${tenantName}` : title)));

  titleService.setCustomTitle([title$]);
};
